import { Model } from 'services/models/model';
import { ObjectMapper } from 'json-object-mapper';
import { IModel } from 'services/models/IModel';
import { ApprovalScopeActionType } from 'services/enums/approvalScopeActionType.enum';
import { SystemModuleType } from 'services/enums/SystemModuleType.enum';

export class ApprovalActionModel extends Model implements IModel<ApprovalActionModel> {
  name: string = '';
  description: string = '';
  actionType: string = ApprovalScopeActionType.NONE.value; // ApprovalScopeActionType
  source: string = '';

  get sourceData(): SystemModuleType {
    return SystemModuleType.getBy(this.source) as SystemModuleType;
  }

  static create(input: any): ApprovalActionModel {
    return ObjectMapper.deserialize<ApprovalActionModel>(ApprovalActionModel, input);
  }
}
